import { render, staticRenderFns } from "./ArticlesSearchField.vue?vue&type=template&id=8c1838dc&scoped=true"
import script from "./ArticlesSearchField.vue?vue&type=script&lang=ts"
export * from "./ArticlesSearchField.vue?vue&type=script&lang=ts"
import style0 from "./ArticlesSearchField.vue?vue&type=style&index=0&id=8c1838dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1838dc",
  null
  
)

export default component.exports